import type { Vector3 } from "@babylonjs/core/Maths/math.vector";
import type { Scene } from "@babylonjs/core/scene";
import type { GridMap } from "../generation/GridMap";
import { hasGridLineOfSight } from "../generation/Pathfinding";
import { hasWorldLineOfSight } from "../rendering/WorldOcclusion";
import { worldToGrid } from "../rendering/worldCoordinates";

export interface PerceptionResult {
  readonly distance: number;
  readonly seesPlayer: boolean;
  readonly hasLineOfSight: boolean;
}

export function perceivePlayer(
  grid: GridMap,
  scene: Scene,
  enemyPosition: Vector3,
  facing: Vector3,
  playerPosition: Vector3,
  detectionRange: number,
  fieldOfViewRadians: number,
): PerceptionResult {
  const offsetX = playerPosition.x - enemyPosition.x;
  const offsetZ = playerPosition.z - enemyPosition.z;
  const distance = Math.hypot(offsetX, offsetZ);
  const facingDot = distance > 0 ? (facing.x * offsetX + facing.z * offsetZ) / distance : 1;
  const inFieldOfView = facingDot >= Math.cos(fieldOfViewRadians / 2);
  const hasLineOfSight =
    hasGridLineOfSight(
      grid,
      worldToGrid(enemyPosition.x, enemyPosition.z, grid),
      worldToGrid(playerPosition.x, playerPosition.z, grid),
      false,
    ) && hasWorldLineOfSight(scene, enemyPosition, playerPosition);
  return {
    distance,
    hasLineOfSight,
    seesPlayer: distance <= detectionRange && inFieldOfView && hasLineOfSight,
  };
}
